<template>
    <div>
        <div class="columns">
            <div class="column" v-if="action == 'create'">
                <h2 class="title is-3">Создать оффер</h2>
            </div>
            <div class="column" v-if="action == 'update'">
                <h2 class="title is-3">Изменить оффер: {{ offer.name }}</h2>
            </div>
        </div>

        <div class="columns">
            <div class="column is-6">
                <b-field label="Название">
                    <b-input v-model="offer.name"></b-input>
                </b-field>
                <b-field label="URL изображения">
                    <b-input v-model="offer.img_path" disabled></b-input>
                </b-field>
                <b-field label="Изображение">
                    <div class="columns">
                        <div class="column is-6">
                            <b-upload v-model="offer.img" accept="image/*" drag-drop>
                                <section class="section">
                                    <div class="content has-text-centered">
                                        <p>
                                            <b-icon icon="upload" size="is-large"> </b-icon>
                                        </p>
                                        <span class="file-name" v-if="offer.img">
                                            {{ offer.img.name }}
                                        </span>
                                        <span v-else>
                                            <p>Загрузить Изображение</p>
                                        </span>
                                    </div>
                                </section>
                            </b-upload>
                        </div>
                        <div class="column is-6">
                            <v-img
                                v-if="offer_img"
                                v-bind:src="offer_img"
                                width="150px"
                                alt="Placeholder image"
                            >
                            </v-img>
                        </div>
                    </div>
                </b-field>
                <b-field label="Дополнительное изображение">
                    <div class="columns">
                        <div class="column is-6">
                            <b-upload v-model="offer.add_img" accept="image/*" drag-drop>
                                <section class="section">
                                    <div class="content has-text-centered">
                                        <p>
                                            <b-icon icon="upload" size="is-large"> </b-icon>
                                        </p>
                                        <span class="file-name" v-if="offer.add_img">
                                            {{ offer.add_img.name }}
                                        </span>
                                        <span v-else>
                                            <p>Загрузить Изображение</p>
                                        </span>
                                    </div>
                                </section>
                            </b-upload>
                        </div>
                        <div class="column is-6">
                            <v-img
                                v-if="offer_add_img"
                                v-bind:src="offer_add_img"
                                max-height="30px"
                                max-width="180px"
                                alt="Placeholder image"
                            >
                            </v-img>
                        </div>
                    </div>
                </b-field>
                <div>
                    <p><b>Шаблоны партнерской ссылки: </b></p>
                    <div class="ml-3 mt-4" v-for="(item, index) in offer.patterns" :key="index">
                        <div class="pb-4">
                            <b-field>
                                <b-input style="width: 100%;" v-model="item.pattern" :disabled="offer.app_id !== 1 && action !== 'create'"></b-input>
                                <b-select v-model="item.partner_id" placeholder="leadgid/leads.su" :disabled="offer.app_id !== 1 && action !== 'create'">
                                    <option
                                        v-for="option in partners"
                                        :value="option.value"
                                        :key="option.id">
                                        {{ option.id }}
                                    </option>
                                </b-select>
                                <p class="control pa-0 ma-0" v-if="index">
                                    <v-btn text color="red" @click="removePattern(index)"
                                        >Удалить</v-btn
                                    >
                                </p>
                            </b-field>
                        </div>
                        <div v-if="patternWeights !== 100 || offer.patterns.length > 1">
                            <b-field
                                label="Процент трафика: "
                                position="center"
                                label-position="on-border"
                            >
                                <b-numberinput
                                    style="width: 100%;"
                                    v-model="item.weight"
                                    step="5"
                                ></b-numberinput>
                            </b-field>
                        </div>
                        <div v-if="index !== offer.patterns.length - 1" class="py-3">
                            <v-divider class="ma-0 pa-0"></v-divider>
                        </div>
                    </div>
                    <div class="py-5">
                        <v-btn class="w100" text color="primary" @click="addPattern()" :disabled="offer.app_id !== 1 && action !== 'create'"
                            >Добавить шаблон</v-btn
                        >
                    </div>
                </div>
                <div style="padding-bottom: 30px;">
                    <p><b>Доступные переменные: </b></p>
                    <p>
                        aff_sub1=<b>{offer_id}</b> - ID оффера в нашей система
                        <span class="tag is-danger">!</span>
                    </p>
                    <p>
                        aff_sub2=<b>{user_uuid}</b> - Уникальный идентификатор пользователя
                        <span class="tag is-danger">!</span>
                    </p>
                    <p>
                        aff_sub3=<b>{lead_uuid}</b> - Зарезервирован для значения идентификатора
                        сделки в нашей системе
                    </p>
                    <p>aff_sub4=<b>{source}</b> - Источник (lk, sms_chain, email_chain)</p>
                    <p>aff_sub5=<b>{service_name}</b> - Название сервиса (mizaem, zaimko и т.д.)</p>
                    <p>aff_sub6=<b>{private_key}</b> - Личный ключ байера</p>
                    <p>
                        api_key=<b>{api_key}</b> - Если не используем aff_sub и отправляем ссылку на
                        витрину
                    </p>
                    <br />
                    <p>
                        <span class="tag is-danger">!</span> - Обязательные параметры, необходимо
                        заполнить для корренктной работы постбеков
                    </p>
                </div>
                <b-field label="Описание">
                    <b-input v-model="offer.description" maxlength="200" type="textarea"></b-input>
                </b-field>
            </div>
            <div class="is-divider-vertical"></div>
            <div class="column is-3">
                <b-field label="Максимальный срок займа">
                    <b-input v-model="offer.days"></b-input>
                </b-field>

                <b-field label="Ставка %">
                    <b-input v-model="offer.bet"></b-input>
                </b-field>

                <b-field label="Процент одобрения">
                    <b-input v-model="offer.success_rate"></b-input>
                </b-field>

                <b-field label="Максимальная сумма займа">
                    <b-input v-model="offer.sum"></b-input>
                </b-field>

                <b-field label="Рейтинг">
                    <b-input v-model="offer.rate"></b-input>
                </b-field>

                <label class="label">Кредитный лимит</label>
                <div class="columns">
                    <div class="column">
                        <b-input v-model="offer.cs_bottom_boundary"></b-input>
                    </div>
                    <div class="column">
                        <b-input v-model="offer.cs_top_boundary"></b-input>
                    </div>
                </div>

                <div class="field">
                    <b-checkbox v-model="offer.extra.use_label">Использовать метку?</b-checkbox>
                </div>

                <div v-if="offer.extra.use_label">
                    <b-field label="Цвет метки">
                        <b-input v-model="offer.extra.label_color"></b-input>
                    </b-field>
                    <b-field label="Текст метки">
                        <b-input v-model="offer.extra.label_text"></b-input>
                    </b-field>
                </div>
            </div>

            <div class="column is-3">
                <b-field label="Показывать пользователям?">
                    <b-switch v-model="offer.show"> </b-switch>
                </b-field>
                <b-field label="Использовать aff_sub параметры?">
                    <b-switch v-model="offer.use_aff_sub_params"> </b-switch>
                </b-field>
                <b-field label="Деньги получаем за">
                    <b-select v-model="offer.is_money_from_approve">
                        <option value="true">выдачу</option>
                        <option value="false">заявку</option>
                    </b-select>
                </b-field>
                <b-field label="Тег (Sunfinance)">
                    <b-select v-model="offer.tag">
                        <option v-for="(tag, index) in tags" :key="index">{{ tag }}</option>
                    </b-select>
                </b-field>
                <b-field label="Тег Aff_sub">
                    <b-input v-model="offer.tag_sub"></b-input>
                </b-field>
                <b-field label="Leadgid Ids">
                    <b-input v-model="offer.leadgid_id"></b-input>
                </b-field>
                <b-field label="Текущая ставка:">
                    <div class="rows" style="margin-left: 12px;">
                        <div class="row">
                            <b-field label="Выплата">
                                <b-input v-model="offer.payout"></b-input>
                            </b-field>
                        </div>
                        <div class="row">
                            <b-field label="Валюта">
                                <b-input v-model="offer.currency"></b-input>
                            </b-field>
                        </div>
                    </div>
                </b-field>
            </div>
        </div>

        <div class="columns" style="margin-top: 20px;">
            <div class="column">
                <b-button
                    class="is-pulled-right"
                    type="is-primary"
                    icon-right="check"
                    @click="save()"
                >
                    Сохранить
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AdminUpdateOffer",
    created() {
        this.$store.dispatch('FETCH_SUNFINANCE_TAGS')
        if (this.offerId && this.action == "update") {
            this.$store.dispatch("GET_OFFER_BY_ID", this.offerId);
        }
    },
    data() {
        return {
            partners:[
                {
                    id: 'leadgid/leads.su',
                    value: null
                },
                {
                    id: 'moneyman',
                    value: 1
                },
                {
                    id: 'sunfinance',
                    value: 2
                },
                {
                    id: 'mizaem-sms',
                    value: 3
                },
                {
                    id: 'keitaro',
                    value: 4
                }
            ]
        };
    },
    computed: {
        offerId() {
            return this.$route.params.id;
        },
        action() {
            return this.$route.name == "UpdateOffer" && this.offerId ? "update" : "create";
        },
        offer: {
            get() {
                return this.$store.getters.CURRENT_OFFER;
            },
            set(value) {
                this.$store.commit("SET_CURRENT_OFFER", value);
            },
        },
        offer_img() {
            if (this.offer.img) {
                return URL.createObjectURL(this.offer.img);
            }
            return this.offer.img_path;
        },
        offer_add_img() {
            if (this.offer.add_img) {
                return URL.createObjectURL(this.offer.add_img);
            }
            return this.offer.add_img_path;
        },
        patternWeights() {
            if (!this.offer.patterns.length) return 0;
            return this.offer.patterns.reduce((prev, cur) => {
                return prev + cur.weight;
            }, 0);
        },
        hasEmptyPattern() {
            return !!this.offer.patterns.some((item) => {
                return !item.pattern;
            });
        },
        tags() {
            return this.$store.getters.SUNFINANCE_TAGS;
        }
    },
    methods: {
        removePattern(index) {
            this.offer.patterns.splice(index, 1);
        },
        addPattern() {
            this.offer.patterns.push({ pattern: "", weight: 10 });
        },

        save() {
            if (this.patternWeights !== 100) {
                this.$toast.warning("Сумма процентного распределения трафика долна равняться 100%");
                return;
            }

            if (this.hasEmptyPattern) {
                this.$toast.warning("Шаблон ссылки не может быть пустым");
                return;
            }
            switch (this.action) {
                case "create":
                    this.$store
                        .dispatch("CREATE_OFFER")
                        .then(() => {
                            this.$toaster.success("Новый оффер создан");
                            this.$router.push({ path: "/admin/offers/" });
                        })
                        .catch(() => {
                            this.$toaster.error("Неизвестная ошибка!");
                        });
                    break;
                case "update":
                    this.$store
                        .dispatch("UPDATE_OFFER", this.offerId)
                        .then(() => {
                            this.$toaster.success("Оффер изменен!");
                        })
                        .catch(() => {
                            this.$toaster.error("Неизвестная ошибка!");
                        });
            }
        },
    },
};
</script>

<style>
.b-numberinput input[type="number"] {
    text-align: center;
    width: 100%;
}
</style>
